import { z } from 'zod'

export const connectionDtoSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  userId: z.string(),
  email: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  connectionName: z.string(),
  description: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  status: z.string(),
  provider: z.string(),
  grantedScopes: z.array(z.string()).nullable().optional(),
  connectedAt: z.string(),
  expiresAt: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
  accessState: z.object({
    status: z.string().nullable().optional(),
    lastCheckedAtUtc: z.string().nullable().optional(),
    errorSummary: z.string().nullable().optional(),
  }).nullable().optional(),
})

export type ConnectionDto = z.infer<typeof connectionDtoSchema>

export const pagedConnectionDataSchema = z.object({
  items: z.array(connectionDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
})

export const pagedConnectionResponseSchema = z.object({
  success: z.boolean(),
  data: pagedConnectionDataSchema,
})

export const testConnectionResultSchema = z.object({
  connectionId: z.string(),
  success: z.boolean(),
  status: z.string(),
  lastCheckedAtUtc: z.string(),
  errorMessage: z.string().nullable().optional(),
})

export type TestConnectionResultDto = z.infer<typeof testConnectionResultSchema>

export const connectionEventSchema = z.object({
  id: z.string().optional(),
  timestamp: z.string(),
  eventType: z.string(),
  status: z.string().optional(),
  errorMessage: z.string().nullable().optional(),
  provider: z.string().nullable().optional(),
  oldStatus: z.string().nullable().optional(),
  newStatus: z.string().nullable().optional(),
  details: z.string().nullable().optional(),
})

export type ConnectionEventDto = z.infer<typeof connectionEventSchema>
